import { render, staticRenderFns } from "./BatchParams.vue?vue&type=template&id=61b8975c&"
import script from "./BatchParams.vue?vue&type=script&lang=js&"
export * from "./BatchParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports